import React from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import { Container } from "reactstrap";

// core components

function TrangskinPageHeader2() {
    let pageHeader = React.createRef();
    const [fullName, setFullName] = React.useState("");

    React.useEffect(() => {
        const currentUser = authenticationService.currentUserValue;

        if (currentUser != null) {
            setFullName(currentUser.fullName);
        }
        else {

            
        }

        if (window.innerWidth > 991) {
            const updateScroll = () => {
                let windowScrollTop = window.pageYOffset / 3;
           
                //pageHeader.current.style.transform = "translate3d(0," + windowScrollTop + "px,0)";
            };
            window.addEventListener("scroll", updateScroll);
            return function cleanup() {
                window.removeEventListener("scroll", updateScroll);
            };
        }
        
    });
    return (
        <>
            <div
                className="page-header clear-filter page-header-small"
                filter-color="blue"
            >
                <div
                    className="page-header-image"
                    style={{
                        backgroundImage: "url(" + require("assets/img/bg5.jpg") + ")"
                    }}
                    ref={pageHeader}
                ></div>
                <Container>
                    <div className="photo-container">
                        <i className="fa fa-user" style={{ fontSize:'7em' }} ></i>
                    </div>
                    <h3 className="title">{fullName}</h3>
                    {/*<p className="category">Photographer</p>*/}
                    {/*
                    <div className="content">
                        <div className="social-description">
                            <h2>26</h2>
                            <p>Comments</p>
                        </div>
                        <div className="social-description">
                            <h2>26</h2>
                            <p>Comments</p>
                        </div>
                        <div className="social-description">
                            <h2>48</h2>
                            <p>Bookmarks</p>
                        </div>
                    </div>
                    */}
                </Container>
            </div>
        </>
    );
}

export default TrangskinPageHeader2;
